'use strict';

class ClaimPayment {
  constructor($timeout, $location, $window, $sce, billingService) {
    this.$timeout = $timeout;
    this.$location = $location;
    this.$window = $window;
    this.$sce = $sce;
    this.billingService = billingService;
    this.showMobileInput = true;

    this.i18n = {
      REJECTED: '<span style="color:red">Betalingen ble ikke gjennomført. Prøv igjen.</span>',
      CANCELLED: '<span style="color:red">Betalingen ble avbrutt. Prøv igjen.</span>',
      FAILED: '<span style="color:red">Betalingen ble ikke registrert. Vennligst kontakt <a href="mailto:hjelp@sendregning.no">hjelp@sendregning.no</a> dersom du har gjort betalingen.</span>',
      PENDING: 'Behandler vippsbetaling...',
      OK: 'Betalingen er registrert<br><br><a href="#/beslutning-kreves" class="button">Gå til beslutning kreves</a>'
    };
  }

  $onInit() {
    this.params = {
      mobileNumber: null
    };
    this.loading = false;
    this.status = null;
    this.counter = 0;

    this.load();
  }

  error() {
    this.loading = false;
    this.showMobileInput = false;
    this.status = this.$sce.trustAsHtml(this.i18n.FAILED);
    this.$timeout.cancel();

    //from parent billing component
    this.getVippsOrders();
  }

  load() {
    const orderId = this.$window.sessionStorage.getItem('vippsOrderId');

    if (orderId !== null) {
      this.loading = true;
      this.showMobileInput = false;
      this.status = this.$sce.trustAsHtml(this.i18n.PENDING);

      this.counter += 1;

      this.billingService.vippsOrderDetails(orderId)
        .then((resp) => {
          if (resp.data.status === 'OK') {
            this.loading = false;
            this.status = this.$sce.trustAsHtml(this.i18n.OK);

            // cleanup
            this.$window.sessionStorage.removeItem('vippsOrderId');
            this.$timeout.cancel();

            //from parent billing component
            this.getVippsOrders();

            // redirect
            // this.$location.path('/beslutning-kreves');
          } else if (resp.data.status === 'PENDING') {
            // stop tying after 60 attempts (~3mins)
            if (this.counter <= 60) {
              this.$timeout(() => this.load(), 3000);
            } else {
              this.error();
            }
          } else if (resp.data.status === 'CANCELLED') {
            this.loading = false;
            this.showMobileInput = true;
            this.status = this.$sce.trustAsHtml(this.i18n.CANCELLED);

            //from parent billing component
            this.getVippsOrders();
          } else if (resp.data.status === 'REJECTED') {
            this.loading = false;
            this.showMobileInput = true;
            this.status = this.$sce.trustAsHtml(this.i18n.REJECTED);

            //from parent billing component
            this.getVippsOrders();
          } else {
            this.error();
          }
        })
        .catch(() => this.error());
    }
  }

  settleVipps() {
    this.billingService.settleVipps(this.params)
      .then((resp) => {
        if (resp.data.orderId && resp.data.orderId !== 'null') {
          this.loading = true;
          this.status = this.$sce.trustAsHtml(this.i18n.PENDING);

          var url = resp.data.url;

          if (url) {
            this.$window.location.href = url;
          }

          // // save order and start checking the status
          this.$window.sessionStorage.setItem('vippsOrderId', resp.data.orderId);
          // this.load();
        }
      })
      .catch((err) => {
        // // console.log(err);
      });
  }
}

ClaimPayment.$inject = ['$timeout', '$location', '$window', '$sce', 'billingService'];

const claimPayment = {
  bindings: {
    getVippsOrders: '&'
  },
  controller: ClaimPayment,
  template: `
    <p>Hvis du betaler med kontooverføring åpner vi kontoen din så snart vi får beskjed om betalingen din, typisk neste virkedag.</p>
    <p>For mer informasjon, vennligst ta kontakt <a href="mailto:hjelp@sendregning.no">hjelp@sendregning.no</a>.</p>

    <div class="row">
      <div class="large-6 columns">
        <fieldset>
          <div class="row">
            <div class="large-3 columns">
              <img src="/assets/img/vipps.png" alt="Vipps" />
            </div>
            <div class="large-9 columns">
              <form ng-submit="$ctrl.settleVipps()">
                <h3 class="subheader">Betal med Vipps</h3>

                <p>Betaler du med Vipps åpner vi kontoen så snart betalingen er gjennomført.</p>

                <div ng-show="$ctrl.showMobileInput">
                  <div>
                    <label for="mobile">Mobilnummer</label>
                    <div class="row collapse">
                      <div class="small-2 columns">
                        <span class="prefix">+47</span>
                      </div>
                      <div class="small-10 columns">
                        <input type="tel" id="mobile" name="mobile" ng-model="$ctrl.params.mobileNumber" required>
                      </div>
                    </div>
                  </div>

                  <button type="submit" style="cursor:pointer; border:none; background-color:#f5f5f5"><img src="/assets/img/vippsPay.png" alt="Vipps"/></button>
                </div>

                <div ng-bind-html="$ctrl.status" ng-show="$ctrl.status"></div>
                <div class="loader" ng-show="$ctrl.loading"></div>
              </form>
            </div>
          </div>
        </fieldset>
      </div>
    </div>
  `
};

angular
  .module('SendRegning')
  .component('claimPayment', claimPayment);
